import { ctxReport } from '@/contexts/ReportCtx';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReportData } from './ReportData';
import AddresseeInput from './AddresseeInput';
import { GenerateButton } from './GenerateButton';
import ReportDriverSelector from './ReportDriverSelector';

export default function DriverTab() {
  const { t } = useTranslation();
  const reportCtx = useContext(ctxReport);
  const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    if (!reportCtx) return;
    const isDisabled = !reportCtx.selectedDrivers || !reportCtx.selectedDrivers.length;
    setDisabled(isDisabled);
  }, [reportCtx]);

  if (!reportCtx) return null;

  return (
    <div id="report-target-container">
      <div id="report-target-selector" data-qa-element-id="multi_element_selector_panel">
        <ReportDriverSelector />
      </div>
      <div id="target-report-data" className={disabled ? 'disabled' : ''} inert={disabled}>
        <h3 id="report-header-h3">{t('report.reportChooser')}</h3>
        <ReportData isListView={false} />
        {reportCtx.selectedTemplateIds.length > 0 && (
          <div id="target-report-data-menu">
            <div className="report-email-conainer">
              <h3 id="report-email-header">{t('report.emailHeader')}</h3>
              <p className="report-comment">{t('report.emailComment')}</p>
              <AddresseeInput />
            </div>
            <div className="report-button-conainer">
              <GenerateButton />
              <p className="report-comment report-generate-comment">{t('report.sendComment')}</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
